import axios from 'axios'
import router from '../../router'

/**
 * initial state
 */
const state = () => ({
  // todo
})

/**
 * getters
 */
const getters = {
  // todo
}

/**
 * mutations
 */
const mutations = {
  // todo
}

/**
 * actions
 */
const actions = {
  /**
   * List Quotation
   */
  /**
   * List Quotation
   */
  getProductCode(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API list productcode params ::', credentials)
      axios
        .get(process.env.VUE_APP_RENEWAL_CMS_GET_PRODECT)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  /**
   * View Quotation Detail
   * @param paTamjaiId
   * @return {array}
   */
  viewQuotationDetail(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_RENEWAL_CMS_GET_DETAIL + '/' + credentials.quotationId)
        .then((response) => {
          console.log('API view quotation detail ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              if (response.data.data.hash_id == null) {
                resolve('No content')
                console.error('No content')
                router.push({ name: 'history' })
              }
              // isSuccess
              resolve(response.data.data)
            } else {
              // !isSuccess
              reject(response.data.message)
            }
          } else reject(response.data)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  /**
   * Approve quotation function
   */

  reportRawData(context, credential) {
    return new Promise((resolve, reject) => {
      // console.log('report cia params ::', credential)
      const params = {
        startDate: credential.startDate,
        endDate: credential.endDate,
      }
      console.log('report Excel params ::', params)
      axios
        .post(process.env.VUE_APP_RENEWAL_CMS_REPORT_RAW, params)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
  updatedPayment(context, credential) {
    return new Promise((resolve, reject) => {
      const param = credential
      console.log('API update payment ::', param)
      axios
        .post(process.env.VUE_APP_UPLOAD_PAYMENT_RENEWAL, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  fileUpload(context, credentials) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('file', credentials.file)
      formData.append('apply_next_month', credentials.isCheck)

      axios
        .post(process.env.VUE_APP_RENEWAL_CMS_UPLOAD, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  reportUpload(context, credential) {
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      formData.append('file', credential.file)

      axios
        .post(process.env.VUE_APP_RENEWAL_CMS_REPORT_UPLOAD, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },

  /**
   * Quick Pay
   */
  async clickQuickPay(context, credentials) {
    try {
      console.log('API quick pay =>', credentials)
      const res = await axios.post(process.env.VUE_APP_RENEWAL_PAYMENT_QUICK_PAY + `/${credentials.hashId}`, {
        email: credentials.email,
        phone: credentials.phone,
      })

      if (res.status === 200 && res.data.isSuccess) {
        return res
      } else return false
    } catch (error) {
      console.log(error)
      return false
    }
  },

  /**
   * Aycap Click
   */
  async clickAycapPay(context, credentials) {
    try {
      console.log('API aycap pay =>', credentials)
      const res = await axios.post(process.env.VUE_APP_RENEWAL_PAYMENT_AYCAP + `/${credentials.hashId}`, {
        email: credentials.email,
        phone: credentials.phone,
      })

      if (res.status === 200 && res.data.isSuccess) {
        return res
      } else return false
    } catch (error) {
      console.log(error)
      return false
    }
  },

  getLogs(context, credentials) {
    return new Promise((resolve, reject) => {
      const params = {
        page: credentials.page,
        limit: credentials.limit,
        order: credentials.order,
        sort: credentials.sort,
      }
      axios
        .post(process.env.VUE_APP_RENEWAL_GET_LOG + `/${credentials.hashId}`, params)
        .then((res) => resolve(res.data.data))
        .catch((err) => reject(err))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
